module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//4.jpg?2a0bf15515292c596af1a79ab5dd1cf5";